/*
 * @Author: libo 
 * @Date: 2020-11-13 17:26:14 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-06-16 10:51:17
 */

<!--批量导入界面-->
<template>
    <a-modal
        :title="title"
        :width="1000"
        :ok=false
        :visible="visible"
        :confirmLoading="confirmLoading"
        :okButtonProps="{ props: {disabled: disableSubmit} }"
        :maskClosable="maskClosable"
        @ok="handleOk"
        @cancel="handleCancel"
        
        :cancelText="$t('关闭')">
        <template slot="footer">
        <a-button key="close" @click="handleCancel">
            {{ $t('关闭') }}
        </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
            <a-steps :current="current">
                <a-step v-for="item in steps" :key="item.title" :title="$t(item.title)"></a-step>
            </a-steps>
            <a-form-model ref="formModal" :model="model" :rules="rules">
                <a-row :gutter="24" v-show="current == 0">
                    <a-card :bordered="false">
                        <!-- 查询区域 -->
                        <div class="table-page-search-wrapper">
                            <a-form layout="inline" @keyup.enter.native="searchQuery">
                                <a-row :gutter="24">
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('方案名称')">
                                    <a-input :placeholder="$t('请输入升级方案名称')" v-model="queryParam.fotaTaskName"></a-input>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('新固件版本号')">
                                    <a-input :placeholder="$t('请输入新固件版本号')" v-model="queryParam.softwareNewVersion"></a-input>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                                    </span>
                                </a-col>
                                </a-row>
                            </a-form>
                        </div>
                        <!-- table区域-begin -->
                        <div>
                            <a-table
                                ref="table"
                                size="middle"
                                :scroll="{x:true}"
                                bordered
                                rowKey="id"
                                :columns="columns"
                                :dataSource="dataSource"
                                :pagination="ipagination"
                                :loading="loading"
                                :rowSelection="{type: 'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange,onSelect:onTableSelect,onSelectAll:onSelectAll}"
                                class="j-table-force-nowrap"
                                @change="handleTableChange">
                            </a-table>
                        </div>
                    </a-card>
                </a-row>
                <a-row :gutter="24" v-show="current == 1">
                    <a-card :bordered="false">
                        <!-- 查询区域 -->
                        <div class="table-page-search-wrapper">
                            <a-form layout="inline" @keyup.enter.native="searchDeviceQuery">
                                <a-row :gutter="24">
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('表编号')">
                                    <a-input :placeholder="$t('请输入表编号')" v-model="queryDeviceParam.meterId"></a-input>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('表类型')">
                                    <a-select v-model="queryDeviceParam.mtCode" :placeholder="$t('请选择表类型')">
                                        <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                                        {{data.mtCode}}
                                        </a-select-option>
                                    </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('表口径')">
                                    <a-select v-model="queryDeviceParam.mtCaliber" :placeholder="$t('请选择表口径')">
                                        <a-select-option v-for="data in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                                            DN{{data.mtCaliber}}
                                        </a-select-option>
                                    </a-select>
                                    </a-form-item>
                                </a-col>
                                <template v-if="toggleSearchStatus">
                                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('运营商')">
                                        <j-dict-select-tag v-model="queryDeviceParam.mtIotType" :placeholder="$t('请选择运营商')" dictCode="mtIotType" />
                                    </a-form-item>
                                    </a-col>
                                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('imei号')">
                                        <a-input :placeholder="$t('请输入imei号')" v-model="queryDeviceParam.mtImei"></a-input>
                                    </a-form-item>
                                    </a-col>
                                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('使用状态')">
                                        <a-select v-model="queryDeviceParam.mtState" style="width: 100%" :placeholder="$t('请选择使用状态')">
                                        <a-select-option :value="0">
                                            {{ $t('未建档') }}
                                        </a-select-option>
                                        <a-select-option :value="1">
                                            {{ $t('已建档') }}
                                        </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                    </a-col>
                                </template>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                                    <a-button type="primary" @click="searchDeviceQuery" icon="search">{{ $t('查询') }}</a-button>
                                    <a-button type="primary" @click="searchDeviceReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                                    <a @click="handleToggleSearch" style="margin-left: 8px">
                                        {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                                        <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                                    </a>
                                    </span>
                                </a-col>
                                </a-row>
                            </a-form>
                        </div>
                        <!-- table区域-begin -->
                        <div>
                            <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="deviceSelectedRowKeys.length > 0">
                                <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: deviceSelectedRowKeys.length }) }}
                                <a style="margin-left: 24px" @click="deviceOnClearSelected">{{ $t('清空') }}</a>
                            </div>
                            <a-table
                                ref="table"
                                size="middle"
                                :scroll="{x:true}"
                                bordered
                                rowKey="id"
                                :columns="deviceColumns"
                                :dataSource="deviceDataSource"
                                :pagination="deviceIpagination"
                                :loading="deviceLoading"
                                :rowSelection="{selectedRowKeys: deviceSelectedRowKeys,onSelect: deviceOnSelect, onChange: deviceOnSelectChange,onSelectAll:deviceOnSelectAll}"
                                class="j-table-force-nowrap"
                                @change="handleDeviceTableChange">
                                <span slot="mtState" slot-scope="text, record">
                                <StateNetwork :status="record.mtState"></StateNetwork>
                                </span>
                            </a-table>
                        </div>
                    </a-card>
                </a-row>
                <a-row :gutter="24" v-show="current == 2">
                    <a-col :span="24" style="margin-top: 24px">
                        <a-descriptions :title="$t('升级包信息')" bordered size="small">
                            <a-descriptions-item :label="$t('方案名称')">
                                {{selectionRows.length>0?selectionRows[0].fotaTaskName: ''}}
                            </a-descriptions-item>
                            <a-descriptions-item :label="$t('软件包名称')">
                                {{selectionRows.length>0?selectionRows[0].softwareNewName: ''}}
                            </a-descriptions-item>
                            <a-descriptions-item :label="$t('软件包版本')">
                                {{selectionRows.length>0?selectionRows[0].softwareNewVersion: ''}}
                            </a-descriptions-item>
                            
                        </a-descriptions>
                    </a-col>
                    <a-col :span="24" style="margin-top: 24px">
                        <label>{{ $t('设备信息') }}</label>
                        <a-table
                                ref="table"
                                size="middle"
                                :scroll="{x:true}"
                                bordered
                                rowKey="id"
                                :columns="deviceColumns"
                                :dataSource="deviceSelectionRows"
                                :pagination="false"
                                :loading="deviceLoading"
                                class="j-table-force-nowrap"
                               >
                                <span slot="mtState" slot-scope="text, record">
                                <StateNetwork :status="record.mtState"></StateNetwork>
                                </span>
                            </a-table>
                    </a-col>
                </a-row>
            </a-form-model>
            <div class="steps-action">
                <a-button v-if="current > 0" style="margin-left: 8px" @click="prev">
                    {{ $t('上一步') }}
                </a-button>
                <a-button v-if="current < steps.length - 1" type="primary" @click="next">
                    {{ $t('下一步') }}
                </a-button>
                <a-button
                    v-if="current == steps.length - 1"
                    type="primary"
                    @click="handleOk"
                >
                    {{ $t('完成') }}
                </a-button>
                
            </div>
        </a-spin>
    </a-modal>
</template>

<script>
    import { getAction,postAction } from '@/api/manage'
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import { isUndefined } from'@/utils/validate'
    import { listSize,filterObj } from '@/utils/util'
    import {netTypeObj} from '@/utils/constants/protocolConstant'

    export default {
        name: 'remoteUpBatchModal',
        mixins:[JeecgListMixin],
        components: {
        },
        props: {
        //表单禁用
        disabled: {
            type: Boolean,
            default: false,
            required: false
        }
        },
        data () {
            return {
                visible: false,
                disableSubmit:false,
                maskClosable:false,
                model: {},
                confirmLoading: false,
                rules:{
                },
                current: 0,
                steps: [
                    {title: this.$t('升级包选择')},
                    {title: this.$t('设备信息')},
                    {title: this.$t('完成')}
                ],
                disableMixinCreated: false,
                /* 数据源 */
                deviceDataSource:[],
                deviceSelectionRows: [],
                /* 分页参数 */
                deviceIpagination:{
                    current: 1,
                    pageSize: 10,
                    pageSizeOptions: ['10', '20', '30'],
                    showTotal: (total, range) => {
                    return range[0] + '-' + range[1] + ' ' + this.$t('共{total}条', { total: total })
                    },
                    showQuickJumper: true,
                    showSizeChanger: true,
                    total: 0
                },
                deviceLoading: false,
                deviceSelectedRowKeys: [],
                userTypeList:[],  //表类型
                userCaliberList:[],  // 表口径
                queryDeviceParam: {},
                url: {
                    list: "/jeecg-charge/meter/meterFotaSoft/list",
                    deviceList: "/jeecg-charge/meter/meterinfo/list",
                    add: "/jeecg-charge/meter/meterFotaDetail/batchAdd",
                    edit: "/jeecg-charge/meter/meterFotaDetail/edit",
                    userTypeList:"/jeecg-charge/meter/meterType/list",  //表类型请求地址
                    userCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
                },
            }
        },
        computed: {
            // i18n：弹窗标题/表头使用 computed 以响应语言切换
            title() {
                return this.$t('操作')
            },
            columns() {
                return [
                {
                    title: '#',
                    dataIndex: '',
                    key:'rowIndex',
                    width:60,
                    align:"center",
                    customRender:(t,r,index) => {
                    return parseInt(index)+1;
                    }
                },{
                    title:this.$t('方案名称'),
                    align:"center",
                    dataIndex: 'fotaTaskName'
                },{
                    title:this.$t('新固件型号'),
                    align:"center",
                    dataIndex: 'softwareNewName'
                },{
                    title:this.$t('新固件版本号'),
                    align:"center",
                    dataIndex: 'softwareNewVersion'
                },{
                    title:this.$t('备注'),
                    align:"center",
                    dataIndex: 'remark'
                },{
                    title:this.$t('创建时间'),
                    align:"center",
                    dataIndex: 'createTime'
                },{
                    title:this.$t('创建人'),
                    align:"center",
                    dataIndex: 'createBy'
                }
                ]
            },
            deviceColumns() {
                return [
                    {
                        title: '#',
                        dataIndex: '',
                        key:'rowIndex',
                        width:60,
                        align:"center",
                        customRender:(t,r,index) => {
                        return parseInt(index)+1;
                        }
                    },{
                        title:this.$t('表编号'),
                        align:"center",
                        dataIndex: 'meterId'
                    },{
                        title:this.$t('表类型'),
                        align:"center",
                        dataIndex: 'mtCodeName'
                    },{
                        title:this.$t('表口径'),
                        align:"center",
                        dataIndex: 'mtCaliber',
                        customRender: (text,row) => {
                            return 'DN'+text;
                        }
                    },{
                        title:this.$t('运营商'),
                        align:"center",
                        dataIndex: 'mtIotType',
                        customRender:(t,r,index) => {
                        let data = netTypeObj
                        if(isUndefined(data[t])) {
                            return this.$t("其他")
                        }
                        return this.$t(data[t])
                        }
                    },{
                        title:this.$t('水表用途'),
                        align:"center",
                        dataIndex: 'mtUseType',
                        customRender:(t,r,index) => {
                        let data = {"1": "结算","2":"考核"}
                        if(isUndefined(typeof data[t])) {
                            return this.$t("其他")
                        }
                        return this.$t(data[t])
                        }
                    },{
                        title:this.$t('使用状态'),
                        align:"center",
                        dataIndex: 'mtState',
                        scopedSlots: { customRender: 'mtState' },
                    },{
                        title:this.$t('是否带阀门'),
                        align:"center",
                        dataIndex: 'mtHasValve',
                        customRender:(t,r,index) => {
                        let data = {"0": "否","1":"是"}
                        if(isUndefined(typeof data[t])) {
                            return this.$t("其他")
                        }
                        return this.$t(data[t])
                        }
                    },{
                        title:this.$t('IMEI号'),
                        align:"center",
                        dataIndex: 'mtImei'
                    },{
                        title:this.$t('sim卡号'),
                        align:"center",
                        dataIndex: 'mtSim'
                    },{
                        title:this.$t('创建时间'),
                        align:"center",
                        dataIndex: 'createTime'
                    },{
                        title:this.$t('创建人'),
                        align:"center",
                        dataIndex: 'createBy'
                    }
                ]
            },
        },

        methods: {
            add() {
                this.edit({});
            },
            edit (record) { 
                this.visible = true;
                this.model = Object.assign(this.model,record);
                this.loadData(1);
                this.queryUserTypeList()
                this.queryUserCaliberList()
            },
            next() {
                if(this.current === 0) {
                    console.log(this.selectedRowKeys)
                    if(this.selectedRowKeys.length === 0) {
                        this.$message.error(this.$t("请选择升级包"))
                        return
                    }
                    this.loadDeviceData(1)
                    this.current++
                }else if(this.current === 1) {
                    if(this.deviceSelectedRowKeys.length===0) {
                        this.$message.error(this.$t("请选择升级设备"))
                        return
                    }
                    this.current++
                }
            },
            prev() {
                this.current--;
            },
            handleOk(){
                console.log(this.deviceSelectionRows)
                if(this.deviceSelectionRows.length<1) {
                    this.$message.error(this.$t("请选择设备"))
                    return
                }
                let meterIdList = []
                for(let i = 0;i<this.deviceSelectionRows.length;i++) {
                    meterIdList.push(this.deviceSelectionRows[i].meterId)
                }
                let formData = {meterIdList: meterIdList.join(','),meterFotaTaskId: this.selectionRows[0].id,meterFotaTaskName: this.selectionRows[0].fotaTaskName}
                console.log(formData)
                postAction(this.url.add,formData).then((res)=> {
                    if(res.success&&res.code === 0) {
                        this.$message.success(this.$t("添加成功"))
                        this.$emit('ok')
                    }else{
                        this.$message.error(res.message)
                    }
                })
            },
            close () {
                this.$emit('close');
                this.disableSubmit = false;
                /*
                this.selectionRows = [];
                this.deviceSelectionRows = [];
                this.deviceSelectedRowKeys = [];
                this.selectedRowKeys = [];
                this.current = 0;
                */
               console.log("关闭");
                Object.assign(this.$data, this.$options.data.call(this));
                console.log(this.$data);
                this.visible = false;
            },
            handleCancel () {
                this.close();
            },
            deviceOnSelectChange(selectedRowKeys, selectionRows) {
                this.deviceSelectedRowKeys = selectedRowKeys;
                //this.deviceSelectionRows = selectionRows
            },
            deviceOnSelect(record, selected, selectedRows) {
                if(selected) {
                    this.deviceSelectionRows.push(record)
                }
                if(!selected){
                    let delIndex = this.deviceSelectionRows.findIndex(val => {
                    return val.id === record.id
                    })
                    this.deviceSelectionRows.splice(delIndex, 1);
                }
            },
            deviceOnClearSelected() {
                this.deviceSelectedRowKeys = [];
                this.deviceSelectionRows = [];
            },
            // 因为翻页后勾选的显示不出来，所以改为onSelect方法，但是onSelect方法中全选/取消按钮不能执行，故需要此方法处理全选/取消事件
            deviceOnSelectAll(selected, selectedRows, changeRows) {
                if(selected) {
                    this.deviceSelectionRows = this.deviceSelectionRows.concat(changeRows);
                }else{
                    for(let i = 0;i<changeRows.length;i++) {
                    let delIndex = this.deviceSelectionRows.findIndex(val => {
                        return val.id === changeRows[i].id
                    })
                    this.deviceSelectionRows.splice(delIndex, 1);
                    }
                }
            },
            handleDeviceTableChange(pagination, filters, sorter) {
                //分页、排序、筛选变化时触发
                //TODO 筛选
                if (Object.keys(sorter).length > 0) {
                    this.isorter.column = sorter.field;
                    this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
                }
                this.deviceIpagination = pagination;
                this.loadDeviceData();
            },
            searchDeviceQuery() {
                this.loadDeviceData(1);
            },
            searchDeviceReset() {
                this.queryDeviceParam = {}
                this.loadDeviceData(1);
            },
            getQueryDeviceParams() {
                //获取查询条件
                var param = Object.assign({},this.queryDeviceParam);
                param.pageNo = this.deviceIpagination.current;
                param.pageSize = this.deviceIpagination.pageSize;
                return filterObj(param);
            },
            loadDeviceData(arg) {
                //加载数据 若传入参数1则加载第一页的内容
                if (arg === 1) {
                    this.deviceIpagination.current = 1;
                }
                var params = this.getQueryDeviceParams();//查询条件
                this.deviceLoading = true;
                getAction(this.url.deviceList, params).then((res) => {
                    if (res.success) {
                    this.deviceDataSource = res.result.records;
                    this.deviceIpagination.total = res.result.total;
                    }
                    if(res.code===510){
                    this.$message.warning(res.message)
                    }
                    this.deviceLoading = false;
                })
            },
            queryUserTypeList() {   //表类型请求
                let params = {}
                params.pageNo = 1;
                params.pageSize = listSize;
                getAction(this.url.userTypeList, params).then((res) => {
                    if(res.success){
                        this.userTypeList = res.result.records;
                    }
                }) 
            },
            queryUserCaliberList() {   //表口径请求
                let params = {}
                params.pageNo = 1;
                params.pageSize = listSize;
                getAction(this.url.userCaliberList, params).then((res) => {
                    if(res.success){
                        this.userCaliberList = res.result.records;
                    }
                }) 
            },
        }
    }
</script>

<style scoped>
.ant-form-item >>> .ant-select{
  width: 100%;
}
.span {
  margin: 8px;
}
.background{
  background-color:rgb(238,238,238)
}
.detail-list >>> .content{
  line-height: normal;
}
</style>